
<template>
  <div
    class="footer-email-collection"
    :class="[schema.settings.backgroundColor, schema.settings.borderColor]"
  >
    <div class="footer-email-collection__content">
      <div class="footer-email-collection__inner-content">
        <div class="footer-email-collection__text">
          <h6
            class="footer-email-collection__title"
            :class="[schema.settings.headerColor]"
          >{{ schema.settings.title }}</h6>
          <div
            class="footer-email-collection__body client-generated"
            v-html="schema.settings.body"
            :class="[schema.settings.textColor]"
          ></div>
        </div>
        <div class="footer-email-collection__form" ref="mailchimp">
          <div id="mc_embed_signup">
            <form
              :action="bvaccel.mailchimp.postUrl"
              method="post"
              id="mc-embedded-subscribe-form"
              name="mc-embedded-subscribe-form"
              class="validate"
              target="_blank"
              novalidate
            >
              <div id="mc_embed_signup_scroll">
                <div class="mc-field-group">
                  <label for="mce-EMAIL">Email Address</label>
                  <input type="email" value name="EMAIL" class="required email mce-email-input" :class="[schema.settings.textColor]" id="mce-EMAIL" placeholder="email@example.com" />
                  <button
                    type="submit"
                    value="Subscribe"
                    name="subscribe"
                    id="mc-embedded-subscribe"
                  >
                    <icon name="arrow_long_right" size="30px" />
                  </button>
                </div>
                <div id="mce-responses" class="clear">
                  <div class="response" id="mce-error-response" style="display: none"></div>
                  <div class="response" id="mce-success-response" style="display: none"></div>
                </div>
                <!-- real people should not fill this in and expect good things - do not remove this or risk form bot signups-->
                <div style="position: absolute; left: -5000px" aria-hidden="true">
                  <input
                    type="text"
                    :name="bvaccel.mailchimp.honeyPot"
                    tabindex="-1"
                    value
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '../basic/Icon.vue';

export default {
  name: 'FooterEmailCollection',
  components: {
    Icon
  },
  data() {
    return {
      bvaccel: window.bvaccel
    }
  },
  props: {
    schema: Object,
    newsletter: String,
  },
};
</script>

<style lang="scss">
.footer-email-collection {

  &__content {
    position: relative;
    display: flex;
    padding-top: 24px;
    flex-direction: column;
    align-items: center;

    @include tablet-up {
      padding: 32px 0 28px;
      flex-direction: row;
      justify-content: center;
    }
    @include desktop-up {
      margin: 0 auto;
      padding: 0;
    }
  }

  &__inner-content {
    width: 100%;
    @include tablet-up {
      margin: 0 auto;
    }
  }

  &__text {
    margin-bottom: 32px;
    @include mobile-only {
      text-align: center;
    }

    .footer-content--center & {
      @include mobile-only {
        text-align: center;
      }
    }
  }

  &__title {
    margin-bottom: 16px;

    @include tablet-up {
      margin-bottom: 12px;
    }
    @include desktop-up {
      width: 100%;
    }
    @include mobile-only {
      font-size: rem(20);
    }
  }

  &__body {
    margin-bottom: 16px;
    font-size: rem(12);
    line-height: 18px;

    @include tablet-up {
      margin-bottom: 12px;
    }
    @include desktop-up {
      margin-bottom: 0;
    }

    p,
    span,
    em,
    strong {
      font-size: inherit;
      line-height: inherit;
      color: inherit;
    }
  }

  &__form {
    width: 100%;
    margin-bottom: 16px;

    @include tablet-up {
      margin-bottom: 0;
    }
    @include desktop-up {
      margin-top: 4px;
      flex-basis: 45%;
    }

    .newsletter-form-inner-container {
      &:hover {
        cursor: pointer;

        button[type='submit'] {
          color: $color-white;
        }

        svg {
          fill: $color-white !important;
        }
      }
    }

    .errors {
      font-size: rem(10);
      line-height: 1.6;
      padding: 4px 0 0 0;

      ul,
      li {
        font-size: inherit;
        line-height: inherit;
      }
    }
  }

  &__image-wrapper {
    @include tablet-up {
      position: absolute;
      bottom: 0;
      left: 20px;
      width: 20%;
    }
    @include desktop-up {
      position: relative;
      bottom: auto;
      left: auto;
      width: auto;
      margin-right: 40px;
      order: 1;
      align-self: flex-end;
    }
  }

  &__image {
    display: block;
  }
}

.mce-email-input {
  appearance: none;
  -webkit-appearance: none;
  width: 100%;
  max-width: 440px;
  border-width: 0px;
  padding: 12px 5px 12px 0;
  font-size: rem(16);
  line-height: rem(22);
  background-color: $color-black;
  &::placeholder {
    font-size: rem(16);
    line-height: rem(22);
    color: $color-grey;
  }
}

.mc-field-group label {
  display: none;
}

.mc-field-group {
  position: relative;
  border-bottom: 1px solid $color-white;
}

#mc-embedded-subscribe {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  svg {
    fill: $color-white;
  }
}
</style>
